import { ProductMetadata } from 'indices-list'
import Big from 'big.js'
import { GradientTagline } from '../../components/index-cover/services'
import { currencyFormat } from 'utils/formatting-utils'

//HoF to inject APR into tagline and add gradient text
export const withApr =
  (apr: Big) =>
  (product: ProductMetadata): GradientTagline => {
    const regularText = product.tagLine
    const gradientText = ` ${apr.toFixedSpecial(2)}% APR`
    return { regularText, gradientText }
  }

export const getStakingCoverInformation = (totalStaked: Big, yourStakedAmount: Big) => {
  return [
    {
      label: 'Your PHTR staked',
      value: yourStakedAmount.eq(0)
        ? '0'
        : currencyFormat(yourStakedAmount.toFixedSpecial(5)).replace('$', '').trim(),
    },
    {
      label: 'Total PHTR staked',
      value: currencyFormat(totalStaked.toFixedSpecial(5)).replace('$', '').trim(),
    },
  ]
}
